<style src="./ReactivePayment.scss" lang="scss"></style>
<template>
  <div class="wrapper wrapper-content animated fadeIn ReactivePayment">
    <div class="mail-box-header">
      <form class="row" @submit.prevent="listRegisters">
        <div class="col-lg-4">
          <div class="input-group col-lg-12">
            <input
              type="text"
              class="form-control"
              placeholder="Código da notificação"
              v-model="searchForm.creditCode"
            />
          </div>
        </div>
        <div class="col-lg-3">
          <div class="input-group col-lg-12">
            <input
              type="text"
              class="form-control"
              placeholder="Placa do veículo"
              v-model="searchForm.licencePlate"
            />
          </div>
        </div>
        <div class="col-lg-3">
          <div class="input-group col-lg-12">
            <input
              type="checkbox"
              class="form-check-input"
              v-model="searchForm.onlyWithUser"
            />
            <label class="form-check-label checkboxlabel">Com Usuário</label>
          </div>
        </div>
        <div class="col-lg-2">
          <div class="input-group col-lg-12">
            <button class="btn btn-lg btn-primary" :disabled="isSearchDisabled">
              <i class="fa fa-search"></i>
              Buscar
            </button>
          </div>
        </div>
      </form>
    </div>

    <spinner v-if="showSpinner" />

    <PaymentsList :list="list" @refresh="listRegisters" />
  </div>
</template>
<script>
import Spinner from '@/components/Spinner';
import PaymentsList from './components/payments-list/PaymentsList.vue';
export default {
  components: { Spinner, PaymentsList },
  data: () => ({
    searchForm: {
      licencePlate: '',
      creditCode: '',
      onlyWithUser: false,
    },
    isSearchDisabled: false,
    showSpinner: false,
    list: [],
  }),
  methods: {
    async listRegisters() {
      const payload = {
        pageLimit: 30,
        pageSkip: 0,
        listAuthorized: true,
        listNotAuthorized: true,
        creditCode: this.searchForm.creditCode.trim(),
        licencePlate: this.searchForm.licencePlate.trim(),
        onlyWithUser: !!this.searchForm.onlyWithUser,
      };

      this.isSearchDisabled = true;
      this.showSpinner = true;
      const list = await this.$store.dispatch(
        'REACTIVE-PAYMENT/ListRegisters',
        payload,
      );
      this.list = list;
      this.isSearchDisabled = false;
      this.showSpinner = false;
    },
  },
};
</script>
